"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _collection = require("lodash/collection");

var _object = require("lodash/object");

var _getAmazonTag = _interopRequireDefault(require("./getAmazonTag"));

var _Bidder = _interopRequireDefault(require("../../utils/Bidder"));

var _BidResponse = _interopRequireDefault(require("../../utils/BidResponse"));

var _logger = _interopRequireDefault(require("../../utils/logger"));

var _getUSPString = _interopRequireDefault(require("../../utils/getUSPString"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var amazonBidderName = 'amazon';
/**
 * Given an ad ID and the tab-ads config, return the first listed
 * size for that ad ID. This is because Amazon does not return useful
 * size info.
 * @param {Object} config - the tab-ads config object
 * @param {String} adId - the ad ID
 * @return {String} A string of the size, such as "728x90"
 */

var getAdSizeByAdId = function getAdSizeByAdId(config, adId) {
  var newTabAds = (0, _object.get)(config, 'newTabAds');
  var adInfo = (0, _object.get)((0, _collection.filter)(newTabAds, {
    adId: adId
  }), '[0]', {});
  var sizeArray = (0, _object.get)(adInfo, 'sizes.[0]', [0, 0]); // default to 0x0

  return "".concat(sizeArray[0], "x").concat(sizeArray[1]);
};
/**
 * Given Amazon bid responses, return an object with keys set to adIds
 * and values set to an array of BidResponses for that adId.
 * @param {Object} config - the tab-ads config object
 * @param {Array} rawBidData - Amazon's bid response
 * @return {Object} bidResponses - An object with keys equal to each adId
 *   for which there's a bid and values with an array of BidResponses, the
 *   bidder's normalized bids for that ad.
 */


var normalizeBidResponses = function normalizeBidResponses(config) {
  var rawBidData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []; // Raw bid object structure:
  // {
  //   amznbid: '1', // the encoded CPM value
  //   amzniid: 'some-id',
  //   amznp: '1',
  //   amznsz: '0x0',
  //   size: '0x0',
  //   slotID: 'div-gpt-ad-123456789-0'
  // }

  var normalizeBid = function normalizeBid(adId, rawBid) {
    // If either amznbid or amazniid are nil or an empty string,
    // that means there's no bid.
    if (!(rawBid.amzniid && rawBid.amznbid)) {
      return null;
    } // Get the ad size from the tab-ads config because Amazon does
    // not return useful ad size info.


    var size = getAdSizeByAdId(config, adId);
    return (0, _BidResponse.default)({
      adId: adId,
      encodedRevenue: rawBid.amznbid,
      advertiserName: amazonBidderName,
      adSize: size
    });
  };

  var normalizedBids = rawBidData.reduce(function (accumulator, rawBid) {
    return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, rawBid.slotID, [normalizeBid(rawBid.slotID, rawBid)].filter(function (item) {
      return !!item;
    })));
  }, {});
  return normalizedBids;
};
/**
 * Return a promise that resolves when the Amazon bids
 * return or the request times out. See:
 * https://ams.amazon.com/webpublisher/uam/docs/web-integration-documentation/integration-guide/javascript-guide/api-reference.html
 * @return {Promise<undefined>} Resolves when the Amazon
 *   bid requests return or time out.
 */


var fetchBids =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(config) {
    var adUnits, consentEnabled, slots, uspString;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            adUnits = config.adUnits, consentEnabled = config.consent.enabled;

            if (adUnits.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.resolve({
              bidResponses: {},
              rawBidResponses: {}
            }));

          case 3:
            slots = adUnits.map(function (adUnit) {
              return {
                slotID: adUnit.adId,
                sizes: adUnit.sizes
              };
            }); // Get the USP string from the consent management platform.

            if (!consentEnabled) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return (0, _getUSPString.default)({
              timeout: config.consent.timeout
            });

          case 7:
            uspString = _context.sent;

          case 8:
            return _context.abrupt("return", new Promise(function (resolve) {
              function handleAuctionEnd(rawBids) {
                _logger.default.debug("Amazon: auction ended");

                resolve({
                  bidResponses: normalizeBidResponses(config, rawBids),
                  rawBidResponses: rawBids
                });
              }

              var apstag = (0, _getAmazonTag.default)();
              apstag.init(_objectSpread({
                pubID: 'ea374841-51b0-4335-9960-99200427f7c8',
                adServer: 'googletag',
                // Privacy docs:
                // https://ams.amazon.com/webpublisher/uam/docs/web-integration-documentation/integration-guide/uam-ccpa.html
                gdpr: {
                  cmpTimeout: consentEnabled ? config.consent.timeout : 0
                }
              }, consentEnabled && uspString && {
                params: {
                  us_privacy: uspString
                }
              }));

              _logger.default.debug("Amazon: bids requested");

              apstag.fetchBids({
                slots: slots,
                timeout: config.bidderTimeout
              }, function (bids) {
                handleAuctionEnd(bids);
              });
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchBids(_x) {
    return _ref.apply(this, arguments);
  };
}();

var setTargeting = function setTargeting() {
  var apstag = (0, _getAmazonTag.default)();
  apstag.setDisplayBids();

  _logger.default.debug("Amazon: set ad server targeting");
};

var AmazonBidder = (0, _Bidder.default)({
  name: amazonBidderName,
  fetchBids: fetchBids,
  setTargeting: setTargeting
});
var _default = AmazonBidder;
exports.default = _default;